import React from "react";

function List(props) {

const listItems = props.items.map((object) => 
    <li>{object}</li>)

  return (
    <div className="md:text-center">
      <h4 className="mt-5 mb-1 text-2xl mx-4">{props.name}</h4>
      <ul className="dark:text-gray-300 text-xs mx-4">
        {listItems}
      </ul>
      <p className="text-sm text-cyan-700 mx-4" >{props.attention}</p>
      
    </div>
  );
}

export default List;
